import { useEffect, useState } from "react"

import { Button, Icon, Label, Table } from "semantic-ui-react"

import { Till } from "../../models/till.model"

import { TillService, HelperService } from "../../services"

import { TillCreateForm, LoadingSpinner, ErrorMessage, NoData } from "../../components"

import { FeedbackMessage } from "../../constants"

export function AdminsysTillsPage() {

    const [tills, setTills] = useState<Till[]>([])
    const [userRole, setUserRole] = useState<string>('')
    const [loadingTills, setLoadingTills] = useState(true)
    const [errorFetchingTills, setErrorFetchingTills] = useState(false)
    const [createModalVisible, setCreateModalVisible] = useState(false)

    useEffect(() => {

        setUserRole(HelperService.getRoleFromToken())

        TillService.getTills('sys')
            .then(data => setTills(data))
            .catch(_ => setErrorFetchingTills(true))
            .finally(() => setLoadingTills(false))
    }, [])


    const addToList = (till: Till) => setTills([...tills, till])

    return <div>
        { loadingTills && <LoadingSpinner />}
        { errorFetchingTills && <ErrorMessage errorText={FeedbackMessage.TILL_FETCH_ERROR} />}
        { !loadingTills && !errorFetchingTills &&
            <div style={{width: '1200px', margin: 'auto'}}>
                <div className='headerRow'>
                        <div className='flex-center'>
                            <h3 className='mb-0 mr-25'><Label color='orange'>{tills.length}</Label> &nbsp; Caisses</h3>
                        </div>
                        { userRole ==='Admin' &&
                            <Button color="orange" className="size-16" onClick={() => setCreateModalVisible(true)}>
                                <Icon name="add circle" />Nouvelle caisse
                            </Button>
                        }
                    </div>
                {
                    tills.length === 0 ? <NoData/> :
                    <Table basic="very">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Compagnie</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Caisse</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Agence</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">État</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Services</Table.HeaderCell>
                                <Table.HeaderCell className="size-17">Actions</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tills.map(t => <Table.Row key={t.id}>
                                <Table.Cell>{t.id}</Table.Cell>
                                <Table.Cell>{t.companyName}</Table.Cell>
                                <Table.Cell>{t.name}</Table.Cell>
                                <Table.Cell>{t.agencyName}</Table.Cell>
                                <Table.Cell>{t.displayedState}</Table.Cell>
                                <Table.Cell>{t.services?.map(s => <p key={s}>{s}</p>)}</Table.Cell>
                                <Table.Cell>
                                    <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                    <Button icon className='mr-10'><Icon name='pencil alternate' /></Button>
                                </Table.Cell>
                            </Table.Row>)}
                        </Table.Body>
                    </Table>
                }
            </div>
        }

        { createModalVisible && <TillCreateForm setCreateModalVisible={setCreateModalVisible} addTillToList={addToList}/> }
    </div>

}
